module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload"
  }, [_c('el-button', {
    staticClass: "back_btn",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "type": "text",
      "icon": "el-icon-arrow-left"
    },
    on: {
      "click": _vm.hanadleBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s((_vm.type == 'material' && _vm.uploading != '') ? "重新" + _vm.upload.title : _vm.upload.title))]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "110px"
    }
  }, [_c('input', {
    staticStyle: {
      "width": "0px",
      "height": "0px",
      "position": "relative",
      "top": "-1000px",
      "background": "#303030"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "label": _vm.upload.name,
      "prop": "name"
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploading == ''),
      expression: "uploading == ''"
    }],
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": _vm.upload.name_placehodler
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", $$v)
      },
      expression: "ruleForm.name"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploading != ''),
      expression: "uploading != ''"
    }],
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v(_vm._s(this.uploading.title))])], 1), _vm._v(" "), (_vm.upload.type_list.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": _vm.upload.type,
      "prop": "type"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.type),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "type", $$v)
      },
      expression: "ruleForm.type"
    }
  }, _vm._l((_vm.upload.type_list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.upload.title,
      "prop": "name"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "action": _vm.upload.url,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.handleBeforeUpload,
      "headers": _vm.header,
      "show-file-list": false,
      "on-success": _vm.hanldeSuccess
    }
  }, [(_vm.file_name != '') ? _c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v(_vm._s(_vm.file_name))]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "upload-btn",
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.upload_loading,
      "disabled": _vm.upload_status
    }
  }, [_vm._v("上传")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "60px",
      "margin-left": "110px",
      "color": "#fff"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.percent > 0),
      expression: "percent > 0"
    }],
    staticClass: "percent"
  }, [_vm._v("上传中" + _vm._s(_vm.percent) + "%")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.percent > 0),
      expression: "percent > 0"
    }],
    staticClass: "progress"
  }, [_c('div', {
    style: (_vm.getWidth)
  })]), _vm._v(" "), _vm._l((_vm.error_info), function(item) {
    return _c('div', {
      staticStyle: {
        "color": "red",
        "line-height": "20px"
      }
    }, [_vm._v(_vm._s(item))])
  })], 2), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "save-btn",
    attrs: {
      "type": "success",
      "loading": _vm.save_status,
      "disabled": _vm.saveStatus
    },
    on: {
      "click": function($event) {
        return _vm.handleSave('ruleForm')
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog_video_visible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_video_visible = $event
      }
    },
    model: {
      value: (_vm.dialog_video_visible),
      callback: function($$v) {
        _vm.dialog_video_visible = $$v
      },
      expression: "dialog_video_visible"
    }
  }, [_c('video', {
    attrs: {
      "id": "video_upload",
      "src": _vm.video_url,
      "controls": "",
      "width": "100%",
      "autoplay": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66cfde3d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Upload/Upload.vue
// module id = 396
// module chunks = 0